var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.166 9.14837V8.25004C20.166 3.66671 18.3327 1.83337 13.7493 1.83337H8.24935C3.66602 1.83337 1.83268 3.66671 1.83268 8.25004V13.75C1.83268 18.3334 3.66602 20.1667 8.24935 20.1667H9.16602",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.916 14.8041V17.2791C11.916 19.3416 12.741 20.1666 14.8035 20.1666H17.2785C19.341 20.1666 20.166 19.3416 20.166 17.2791V14.8041C20.166 12.7416 19.341 11.9166 17.2785 11.9166H14.8035C12.741 11.9166 11.916 12.7416 11.916 14.8041Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/merge.b57a4cedfddbb79b81e70fc3fddbe184.svg";
export { ForwardRef as ReactComponent };